import { createSelector } from 'reselect';

import getFilteredProducts from '../../utils/get-filtered-products';
import selectCustomer from '../select-customer';
import selectProductIdsFromParams from '../select-product-ids-to-load-from-params';
import selectProducts from '../select-products';

const selectFilteredProductsByCustomer = createSelector(
  [selectCustomer, selectProductIdsFromParams, selectProducts],
  (customer, productIds, products) => {
    if (!customer?.hospitalExcess) {
      return null;
    }

    return getFilteredProducts({
      customer,
      productIds,
      products,
    });
  },
);

export default selectFilteredProductsByCustomer;
